import { render, staticRenderFns } from "./PurimGifts.vue?vue&type=template&id=79859ed4&"
import script from "./PurimGifts.vue?vue&type=script&lang=js&"
export * from "./PurimGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports